/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SetBrandDescriptionRequest} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'
import {SetBrandDescriptionResponse} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'


export const setBrandDescription = (request: SetBrandDescriptionRequest, options?: CashRequestOptions) => post<SetBrandDescriptionRequest, SetBrandDescriptionResponse>("/2.0/cash/set-brand-description", request, {...options, rejectOnError: true })